import {
  UnmanagedMessenger,
  targetContextFromWindow,
  noopLogger,
  noopMetrics,
} from '@sail/comms';

export type EmbeddedMessage = {
  type: 'RESIZE';
  payload: {height: number};
};

let messenger: UnmanagedMessenger | null = null;

const getMessenger = (): UnmanagedMessenger => {
  if (!messenger) {
    messenger = new UnmanagedMessenger({
      remote: {
        context: targetContextFromWindow(window.parent),
        origin: '*',
      },
      self: {
        context: targetContextFromWindow(window),
      },
      logger: noopLogger,
      metrics: noopMetrics,
      UNSAFE_allowWildcardOrigin: true, // nosemgrep: ban-unsafe-sail-comms-primitives (EXCEPTION-8542) -- embedder origin is unknown at runtime; only non-sensitive resize data is transmitted
    });
  }
  return messenger;
};

export const postMessageToEmbedder = (message: EmbeddedMessage): void => {
  getMessenger().sendMessage(message);
};
